import React, {
  ReactElement, useCallback,
  useState,
} from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
  FormControl, InputLabel, MenuItem,
  Select, Stack, TextField,
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import api from "../../../services/api";
import { LoadingButton } from '@mui/lab';
import toast from 'react-hot-toast';

export const OfferDateCell = ({
                                props,
                                refresh,
                                schema,
                              }: {
  props: any;
  schema: any;
  refresh: () => void;
}): ReactElement => {

  const [open, setOpen] = useState(false);
  const [offers, setOffers] = useState<any>([]);
  const [value, setValue] = useState<any>('');
  const [customDate, setCustomDate] = useState<any>(`${props.row?.activity_reservation?.date} ${props.row?.activity_reservation?.start_time}`);
  const [loadingSendButton, setLoadingSendButton] = useState<any>(false);
  const [loadingButton, setLoadingButton] = useState<any>(false);

  // Idő konvertálása a megfelelő formátumba
  const formatDateTime = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Hónap (0-alapú, ezért +1)
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleChange = (event: any) => {
    setValue(event.target.value as string);
  };

  const onSubmit = useCallback(
    async (send?: any) => {
      setLoadingButton(true);

      const dateToSave = value === 'custom' ? customDate : value;

      const implodedDate = dateToSave.split(' ');

      if (send){

        await api.post(`/service-reservations/${props?.row?.id}/send`, {
          date: implodedDate[0],
          start_time: implodedDate[1],
          service_reservation_status: {
            id: 5,
            name: 'Modified',
          },
          schemaColumns: schema?.columns,
        })
          .then((res: any) => {
            setLoadingSendButton(true);
            refresh();
            toast.success('Service reservation has been sent');
          })
          .catch((res: any) => {
            toast.error('Error while sending email');
          })
          .finally(() => {
            setOpen(false);
            setLoadingButton(false);
            setLoadingSendButton(false);
          });
      }else{
        await schema.client.update(props?.row?.id, {
          date: implodedDate[0],
          start_time: implodedDate[1],
          service_reservation_status: {
            id: 5,
            name: 'Modified',
          },
          schemaColumns: schema?.columns,
        })
          .then((res: any) => {
              refresh();
            toast.success('Successfully updated reservation');
          })
          .catch((res: any) => {
              refresh();
            toast.success('Error while saving reservation');
          })
          .finally(() => {
            setOpen(false);
            setLoadingButton(false);
            setLoadingSendButton(false);
          });
      }


    },
    [value, customDate, schema]
  );

  return (
    <>

      <Button
        variant="text"
        onClick={(event) => {
          setOpen(true);
          setOffers(props?.row?.date_offers);
        }}
      >
        Select
      </Button>

      {open && (
        <>
          <Dialog open={true} onClose={() => {
            setOpen(false);
          }}>
            <DialogTitle>Choose option</DialogTitle>
            <DialogContent>
              <Stack direction={'row'} gap={1}>
                {offers.length && (
                  <FormControl sx={{mt: '8px', minWidth: '300px'}} fullWidth>
                    <InputLabel>Date</InputLabel>
                    <Select
                      variant={'outlined'}
                      label="Date"
                      value={value}
                      onChange={handleChange}
                    >
                      {offers.map((offer: any) => <MenuItem value={offer}>{offer}</MenuItem>)}
                      <MenuItem value="custom">Custom Date</MenuItem>
                    </Select>

                    {value === 'custom' && (
                      <TextField
                        fullWidth
                        margin="normal"
                        label="Custom Date"
                        type="datetime-local"
                        value={customDate}
                        onChange={(e) => {
                          const formattedDate = formatDateTime(e.target.value);
                          setCustomDate(formattedDate);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}

                  </FormControl>
                )}
              </Stack>

            </DialogContent>
            <DialogActions>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={() => {
                  onSubmit();
                }}
                autoFocus
                loading={loadingSendButton || loadingButton}
              >
                Save
              </LoadingButton>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={() => {
                  onSubmit(true);
                }}
                autoFocus
                loading={loadingSendButton || loadingButton}
              >
                Save and Send to Provider
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </>
      )}

    </>
  );
};
